module.exports = __webpack_public_path__ + "static/media/yogesh_88Yi95lhuI.4f6298fb.jpg";